import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    SidebarVariant
} from "../../type";
import {
    getSurfaceStyle
} from "../../../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    card: {
        overflow: "hidden"
    },
    container: {
        minHeight: 0,
        minWidth: 0,
        flex: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    elevations,
    radiuses,
    borders,
    isPhone,
    variant,
    colors,
    spaces
}: {
    radiuses: NCoreUIKit.ActivePalette["radiuses"];
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    elevations: NCoreUIKit.Elevations;
    borders: NCoreUIKit.Borders;
    variant: SidebarVariant;
    shadowAlpha: number;
    isPhone: boolean;
}) => {
    const styles = {
        container: {
            backgroundColor: colors.content.container.default
        } as Mutable<ViewStyle>
    };

    if(variant === "inset") {
        Object.assign(styles.container, stylesheet.card, getSurfaceStyle({
            surface: "card",
            shadowAlpha,
            elevations,
            borders,
            colors
        }), getCornerStyle({
            radius: radiuses.surface,
            shapeConfigs
        }), {
            backgroundColor: colors.content.container.default,
            marginStart: isPhone ? spaces.spacingSm : 0,
            marginVertical: spaces.spacingSm,
            marginEnd: spaces.spacingSm
        });
    }

    return styles;
};
export default stylesheet;
